(function () {
    'use strict';

    angular.module('AngularAdmin').factory('ModalSvc', ['$modal', '$rootScope', function ($modal, $rootScope) {
        var ModalSvc = {

            // ------ Order ------
            orderEditModal: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/edit_order.html',
                        size: "lg",
                        controller: 'OrderModalCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        openedClass: 'modal-open-fullscreen',
                        backdrop: 'static'
                    });
                }
            },

            viewOrderRequestModal: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/view_order_request.html',
                        size: "lg",
                        controller: 'ViewOrderRequestModalCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        }
                    });
                }
            },

            orderDeleteModal: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/shared/delete_modal.html',
                        controller: 'OrderDeleteModalCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        windowClass: 'order-delete-modal'
                    });
                }
            },
            // ------ Production schedule ------
            productionModeCalendarEntryEditModal: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/edit_production_schedule_entry.html',
                        controller: 'ProductionScheduleEntryModalCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        }
                    });
                }
            },
            productionModeCalendarEntryDeleteModal: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/shared/delete_modal.html',
                        controller: 'ProductionScheduleEntryDeleteModalCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        windowClass: 'production-schedule-entry-delete-modal'
                    });
                }
            },
            // ------ Mix design ------
            mixDesignDeleteModal: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/shared/delete_modal.html',
                        controller: 'MixDesignDeleteModalCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        windowClass: 'mixdesign-delete-modal'
                    });
                }
            },
            // ------ Production Mode ------
            productionModeDeleteModal: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/shared/delete_modal.html',
                        controller: 'ProductionModeDeleteModalCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        windowClass: 'production-mode-delete-modal'
                    });
                }
            },
            // ------ Material ------
            materialDeleteModal: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/shared/delete_modal.html',
                        controller: 'MaterialDeleteModalCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        windowClass: 'material-delete-modal'
                    });
                }
            },
            // ------ Users ------
            inviteUser: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/new_employee_modal.html',
                        controller: 'NewEmployeeModalCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        }
                    });
                }
            },

            //Customers import

            importCustomers: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/customers_import.html',
                        controller: 'ImportCustomersCtrl',
                        resolve: {
                            config: function () {
                                return config;
                            }
                        }
                    });
                }
            },

            // ------ Calendar events ------

            calendarNoteModal: {
                open: function (config, scope) {
                    config = config || {};
                    return $modal.open({
                        templateUrl: '/static/partials/calendar-note-modal.html',

                        controller: "CalendarNoteModalCtrl",
                        scope: scope,
                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        windowClass: 'calendar-note-modal'
                    });
                }
            },

            orderRequestRejectModal: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/modals/order_request_reject_modal.html',

                        controller: ['$scope', 'config', '$modalInstance', function ($scope, config, $modalInstance) {
                            $scope.order_request = config.order_request;

                            $scope.material = Array.findObject(config.output_materials, 'id', config.order_request.material);

                            $scope.cancel = function(){
                                $modalInstance.dismiss();
                            };

                            $scope.confirm = function(){
                                $modalInstance.close($scope.reason);
                            };

                            $scope.reason = "";

                        }],

                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        windowClass: 'order-request-reject-modal'
                    });
                }
            },

            // ------ Shared ------
            alert: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/shared/alert.html',

                        controller: ['$scope', 'config', function ($scope, config) {
                            $scope.message = config.message;
                            $scope.title = config.title;
                        }],

                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        windowClass: 'alert-modal'
                    });
                }
            },
            confirmationDialog: {
                open: function (config) {
                    config = config || {};

                    return $modal.open({
                        templateUrl: '/static/partials/shared/confirmation_dialog.html',

                        controller: ['$scope', 'config', '$modalInstance', function ($scope, config, $modalInstance) {
                            $scope.message = config.message;
                            $scope.title = config.title;

                            $scope.confirm = function () {
                                $modalInstance.close("Confirmed");
                            };

                            $scope.cancel = function () {
                                $modalInstance.dismiss("Cancel clicked");
                            };
                        }],

                        resolve: {
                            config: function () {
                                return config;
                            }
                        },
                        windowClass: 'confirmation-modal'
                    });
                }
            }
        };


        return ModalSvc;
    }]);

})();
